module.exports = __webpack_public_path__ + "static/media/coins.ec867e39.png";